/*
 * @Author: yanyongchao
 * @Date: 2019-01-01 18:00:39
 * @Last Modified by: yanyongchao
 * @Last Modified time: 2019-03-05 11:38:07
 */
import { Post, Get } from 'plugins/axios-php'

/**
 * 查询省
 */
export const getProvinceList = () => {
  return Post('/app/public/get-pa-province')
}

/**
 * 查询省市区
 */
export const getAreaList = (params) => {
  return Post('/app/public/get-pa-area', params)
}

/**
 * 判断是否有硬件参与押金活动
 */
export const whetherExistActivity = (params) => {
  return Post('/appv2/hardware-refund/whether-exist-activity', params)
}

/**
 * 获取平安硬件设备金额与总数
 */
export const getSafeEquipmentData = (params) => {
  return Post('/appv2/hardware-refund/get-safe-data', params)
}

/**
 * 获取非平安硬件设备列表
 * **/
export const getNoSafeEquipmentData = (params) => {
  return Post('/appv2/hardware-refund/get-no-safe-data', params)
}

/**
 * 获取退款须知
 * **/
export const getRefundNotice = (params) => {
  return Post('/appv2/hardware-refund/get-prompt-text', params)
}

/**
 * 获取申请记录
 * **/
export const getApplyRecord = (params) => {
  return Post('/appv2/hardware-refund/get-record-list', params)
}

/**
 * 获取申请详情
 * **/
export const getApplyDetailRes = (params) => {
  return Post('/appv2/hardware-refund/get-apply-detail', params)
}

/**
 * 获取支行信息列表
 */
export const getBranchName = (params) => {
  return Post('/app/public/get-unionpay-code', params)
}

/**
 * 下载申请单接口
 */
export const downloadApplyFormRes = (params) => {
  return Post('/appv2/hardware-refund/download-apply-form')
}

/**
 * 获取配件信息
 */
export const getEquipmentInformation = (params) => {
  return Post('/appv2/hardware-refund/get-equipment-information', params)
}

/**
 * 获取银行卡信息
 */
export const getUserCardInfo = (params) => {
  return Post('/appv2/hardware-refund/get-user-card-info', params)
}

/**
 * 硬件退款表单提交
 */
export const hardwareRefundRes = (params) => {
  return Post('/appv2/hardware-refund/add', params)
}

/**
 * 根据联行号查询支行名称接口
 */
export const getBranchNameByCode = (params) => {
  return Post('/appv2/hardware-refund/get-branch-name-by-code', params)
}

/**
 * 删除申请表
 */
export const deleteApplyFormRes = (params) => {
  return Post('/appv2/hardware-refund/delete', params)
}

/**
 * 美味e点协议
 */
export const getCateAgreement = (params) => {
  return Get('/cate/agreement/get-detail', params)
}

/**
 * 扫码点单协议
 */
export const getCateOrderAgreement = (params) => {
  return Get('/owncate/agreement/get-agreement-detail', params)
}

/**
 * 退款须知保存开户行信息
 */
export const saveBankInfo = (params) => {
  return Post('/appv2/hardware-refund/add', params)
}
/**
 * angular首页show-index-icon权限接口
 * */
export const showIndexIcon = (params) => {
  return Get('/app/index/show-index-icon', params)
}
/**
 * 服务通知详情接口
 * @param {Object} params
 * @param {Number} id
 */
export const getServiceDetailInfo = (params) => {
  return Get('/app/index/get-notice', params)
}
export const actList = (params) => Post('')
